import {
  createTableColumn, DataGrid,
  DataGridBody, DataGridCell,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridRow,
  makeStyles,
  TableColumnDefinition,
} from '@fluentui/react-components';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { IAppValidationItem } from '../abstractions/IAppValidation';

const useStyles = makeStyles({
  header: {
    height: "48px",
  },
  appName: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  }
});

interface IAppValidationDataGridElement {
  id: string;
  createdAt: string;
  version: string;
  manifestVersion: string;
  updatedAt: string;
  status: string;
}

export const AppValidationDataGrid: React.FC<{
  validations: IAppValidationItem[];
  onValidationDetail: (value: string) => void;
}> = ({ validations, onValidationDetail }) => {

  const classes = useStyles();

  const items: IAppValidationDataGridElement[] = validations.map((validation) => {
    const createdAtFormatted = new Date(validation.createdAt).toLocaleDateString(
      'en-US',
      { year: 'numeric', month: 'long', day: 'numeric' }
    );
    const updatedAtFormatted = new Date(validation.updatedAt).toLocaleDateString(
      'en-US',
      { year: 'numeric', month: 'long', day: 'numeric' }
    );
    return {
      id: validation.id ?? "N/A",
      createdAt: createdAtFormatted,
      version: validation.appVersion ?? "N/A",
      manifestVersion: validation.manifestVersion ?? "N/A",
      updatedAt: updatedAtFormatted,
      status: validation.status
    };
  });

  const columns: TableColumnDefinition<IAppValidationDataGridElement>[] = [
    createTableColumn<IAppValidationDataGridElement>({
      columnId: "createdAt",
      renderHeaderCell: () => (
        <FormattedMessage defaultMessage="Created at" description="Header for created at column" />
      ),
      renderCell: (data) => data.createdAt
    }),
    createTableColumn<IAppValidationDataGridElement>({
      columnId: "version",
      renderHeaderCell: () => (
        <FormattedMessage defaultMessage="App version" description="Header for app version column" />
      ),
      renderCell: (data) => data.version
    }),
    createTableColumn<IAppValidationDataGridElement>({
      columnId: "manifestVersion",
      renderHeaderCell: () => (
        <FormattedMessage defaultMessage="Manifest version" description="Header for manifest version column" />
      ),
      renderCell: (data) => data.manifestVersion
    }),
    createTableColumn<IAppValidationDataGridElement>({
      columnId: "updatedAt",
      renderHeaderCell: () => (
        <FormattedMessage defaultMessage="Last updated" description="Header for last updated column" />
      ),
      renderCell: (data) => data.updatedAt
    }),
    createTableColumn<IAppValidationDataGridElement>({
      columnId: "status",
      renderHeaderCell: () => (
        <FormattedMessage defaultMessage="Status" description="Header for status column" />
      ),
      renderCell: (data) => data.status
    }),
  ];

  return (
    <DataGrid items={items} columns={columns}>
      <DataGridHeader>
        <DataGridRow className={classes.header}>
          {({ renderHeaderCell }) => <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>}
        </DataGridRow>
      </DataGridHeader>
      <DataGridBody<IAppValidationDataGridElement>>
        {({ item, rowId }) => (
          <DataGridRow<IAppValidationDataGridElement> key={rowId}>
            {({ renderCell }) => <DataGridCell onClick={() => { onValidationDetail(item.id); }}>{renderCell(item)}</DataGridCell>}
          </DataGridRow>
        )}
      </DataGridBody>
    </DataGrid>
  )
};
